import React from 'react';
import spritemap from '@milestone-sys/web-design-system/msds-spritemap.svg';

export default function Select(props: SelectProps) {
    const {
        label,
        value,
        onChange,
        disabled,
        children,
        errors,
        ...otherProps
    } = props;
    return (
        <div className="msds-select-input mb-6">
            <select
                className="msds-select-input__select"
                style={{background: disabled ? "rgb(235, 239, 242)" : ''}}
                disabled={disabled ?? false}
                onChange={onChange}
                value={value}
                {...otherProps}
            >
                {children}
            </select>
            <div className="msds-select-input__icon">
                <svg>
                    <use href={`${spritemap}#right-arrow`} />
                </svg>
            </div>
            {errors &&
                (typeof errors === 'string' ? [errors] : errors).map(
                    (error, index) => (
                        <p key={index} className="msds-text-danger-red-1">
                            <span className="msds-input__info-message msds-input--error">
                                {error}
                            </span>
                        </p>
                    )
                )}
        </div>
    );
}

type SelectProps = {
    label?: string;
    value?: string;
    onChange?: React.ChangeEventHandler<HTMLSelectElement>;
    disabled?: boolean;
    children: React.ReactNode;
    errors?: string | string[];
    [otherProps: string]: unknown;
};
